// extracted by mini-css-extract-plugin
module.exports = {"primary":"primary__1F90v","primary-body":"primary-body__2u_v0"};